import { Link } from "react-router-dom";
import { ArrowRight, ListChecks } from "lucide-react";
import { C, ZONES } from "./constants";

const ZoneTag = ({ zona }) => (
  <span className="inline-block rounded-md px-2 py-0.5 text-[11px] font-bold" style={{ background: ZONES[zona].bg, color: ZONES[zona].fg }}>
    {zona}
  </span>
);

const AreaCard = ({ r, testId }) => (
  <div className="rounded-xl bg-white p-5 border" style={{ borderColor: "#E3E7E1" }} data-testid={`tablero-area-card-${r.area}`}>
    <div className="flex flex-wrap items-center gap-2 mb-2">
      <span className="text-[12px] font-bold tabular-nums" style={{ color: C.gold }}>#{r.prioridad}</span>
      <span className="text-[15px] font-bold" style={{ color: C.text }}>{r.nombre}</span>
      <ZoneTag zona={r.zona} />
      <span className="text-[12px]" style={{ color: "#5B6B64" }}>Madurez {r.nivel_label.toLowerCase()} · dolor {r.dolor}/5</span>
    </div>
    <p className="text-sm leading-relaxed" style={{ color: C.text }}>{r.texto}</p>
    {r.contraste_nota && <p className="text-[12px] mt-2 font-semibold" style={{ color: "#5B6B64" }} data-testid={`tablero-contraste-nota-${r.area}`}>{r.contraste_nota}</p>}
    <div className="flex flex-wrap gap-2 mt-4">
      {r.tools.map((t) => (
        <Link key={t.key} to={`/consulting/${testId}/tools/${t.key}`} className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-semibold text-white" style={{ background: C.green }} data-testid={`tablero-tool-link-${r.area}-${t.key}`}>
          {t.title} <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      ))}
      <Link to={`/consulting/${testId}/checklist?area=${r.area}`} className="inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-semibold border" style={{ color: C.green, borderColor: C.green }} data-testid={`tablero-checklist-link-${r.area}`}>
        <ListChecks className="w-3.5 h-3.5" /> Acciones en la checklist
      </Link>
    </div>
  </div>
);

export const Capa3Cards = ({ result, testId }) => (
  <div className="space-y-3" data-testid="tablero-area-cards">
    {result.map((r) => <AreaCard key={r.area} r={r} testId={testId} />)}
  </div>
);
